import { Text } from '@simplywallst/ui-core';
import { TooltipTable } from './styled';
import type { Period } from '../../../types/portfolioDividend';
import { extractDividendQualityByPeriod } from '../../../utils/extractPorfolioDividendData';
import { getTooltipContent } from './utils';
import { usePortfolioDividendCreator } from '../../../hooks/usePortfolioDividend';
import { usePortfolioHoldingsDividendForecastCreator } from '../../../hooks/usePortfolioHoldingsDividendForecast';
import type { Portfolio } from '@/hooks/portfolio/usePortfolio';
import type { DemoPortfolio } from '@/hooks/portfolio/useDemoPortfolio';
interface Props {
  selectedPeriod: Period;
  portfolio: Portfolio | DemoPortfolio;
}

export const DividendQualityForecastTooltip = ({
  selectedPeriod,
  portfolio,
}: Props) => {
  const portfolioId = portfolio.id;
  const curencyISO = portfolio.currencyISO;
  const { data: portfolioDividend } = usePortfolioDividendCreator(curencyISO)({
    portfolioId,
  });
  const { data: portfolioDividendHoldingForecast } =
    usePortfolioHoldingsDividendForecastCreator(curencyISO)({ portfolioId });

  const dividendData = extractDividendQualityByPeriod(
    portfolioDividendHoldingForecast
  )[selectedPeriod];

  const data = getTooltipContent({
    data: dividendData,
    currencyISO: portfolioDividend?.Portfolio?.currencyISO,
    selectedPeriod,
  });

  return (
    <TooltipTable>
      <tbody>
        {data.map((item, index) => (
          <tr key={index}>
            <td>
              {item.title && (
                <Text typography="tinyStrong" color="textSolid">
                  {item.title}
                </Text>
              )}
            </td>
            <td>
              {item.value && (
                <Text
                  typography="tinyStrong"
                  color={item.valueColor ?? 'textSolid'}
                >
                  {item.value}
                </Text>
              )}
            </td>
            <td>
              {item.ratio && (
                <Text
                  typography="tinyStrong"
                  color={item.valueColor ?? 'textSolid'}
                >
                  {item.ratio}
                </Text>
              )}
            </td>
            <td>
              {item.holdingsText && (
                <Text typography="tiny" color="textSoft">
                  {item.holdingsText}
                </Text>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </TooltipTable>
  );
};
